import Vue from "vue";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

const dateFilter = value => {
  return formatDate(value);
};
const dateFilterWithHour = value => {
  if (!value || value == "") {
    return "";
  }

  return formatDate(value, true);
};

function formatDate(inputDate, showHour = false) {
  inputDate = inputDate.replace(/-/g, "/");
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  let formattedDate;
  if (showHour) {
    formattedDate =
      months[month] + ", " + day + " " + year + " " + hour + ":" + minutes;
  } else {
    formattedDate = months[month] + ", " + day + " " + year;
  }
  return formattedDate;
}

// Compact date filter: MM/DD/YY
const dateCompact = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${month}/${day}/${year}`;
};

// Short date filter: MM/DD/YYYY
const dateShort = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

// ISO date filter: YYYY-MM-DD
const dateISO = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Time only filter: HH:MM
const timeOnly = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

// Time with seconds: HH:MM:SS
const timeWithSeconds = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

// DateTime compact: MM/DD/YY HH:MM
const dateTimeCompact = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${month}/${day}/${year} ${hours}:${minutes}`;
};

// Relative time (e.g., "2 hours ago", "3 days ago")
const dateRelative = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const now = new Date();
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  const diffMonth = Math.floor(diffDay / 30);
  const diffYear = Math.floor(diffDay / 365);

  if (diffSec < 60) return "Just now";
  if (diffMin < 60) return `${diffMin} minute${diffMin > 1 ? "s" : ""} ago`;
  if (diffHour < 24) return `${diffHour} hour${diffHour > 1 ? "s" : ""} ago`;
  if (diffDay < 30) return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
  if (diffMonth < 12)
    return `${diffMonth} month${diffMonth > 1 ? "s" : ""} ago`;
  return `${diffYear} year${diffYear > 1 ? "s" : ""} ago`;
};

// Full date and time: Jan 15, 2023 at 3:45 PM
const dateFull = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  return date.toLocaleDateString("en-US", options).replace(",", " at");
};

// Day of week: Monday, Tuesday, etc.
const dateDayOfWeek = value => {
  if (!value || value === "") return "";
  const date = new Date(value.replace(/-/g, "/"));
  return date.toLocaleDateString("en-US", { weekday: "long" });
};

// Register all filters
//MM - d - yyyy
Vue.filter("date", dateFilter);

//MM - d - yyyy H:m
Vue.filter("dateWithHours", dateFilterWithHour);

// MM/DD/YY
Vue.filter("dateCompact", dateCompact);

// MM/DD/YYYY
Vue.filter("dateShort", dateShort);

// YYYY-MM-DD
Vue.filter("dateISO", dateISO);

// HH:MM
Vue.filter("timeOnly", timeOnly);

// HH:MM:SS
Vue.filter("timeWithSeconds", timeWithSeconds);

// MM/DD/YY HH:MM
Vue.filter("dateTimeCompact", dateTimeCompact);

// "2 hours ago", "3 days ago"
Vue.filter("dateRelative", dateRelative);

// Jan 15, 2023 at 3:45 PM
Vue.filter("dateFull", dateFull);

// Monday, Tuesday, etc.
Vue.filter("dateDayOfWeek", dateDayOfWeek);
